<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <dash-sidebar defaultSelectedKeys="3" :menuItems="commonMenuItems.admin"/>
    <a-layout>
      <a-layout-content
        :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
      >
      <courses-list-admin-tab
        :firstTabName="'All Courses'"
        :firstTabDataSource="userCourses.submitted"
        :secondTabName="'Reviewers Assigned'"
        :secondTabDataSource="userCourses.inProgress"
        :thirdTabName="'Reviews Completed'"
        :thirdTabDataSource="userCourses.completed"
        :fourthTabName="'Test Courses'"
        :fourthTabDataSource="userCourses.testCourses"
        :userRole="'tela-admin'"
      />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import coursesListAdminTab from '@src/components/dashboard/admin/Courses-list-admin-tab.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';

export default {
  name: 'telas-admin-dashboard',
  components: {
    coursesListAdminTab,
    dashSidebar,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('dashboard', {
      userDetails: 'getUserProfileDetails',
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapState('dashboard', {
      userCourses: state => state.courses.telasAdminCourses,
    }),
  },
  mounted() {
    const submittedCourses = {
      status: 'publish',
      role: 'tela-admin',
      userToken: this.userToken,
      progress: 'submitted',
      'filter[meta_key]': 'forTest',
      'filter[meta_compare]': '!=',
      'filter[meta_value]': 'yes',
    };
    this.getCoursesByUser(submittedCourses);
    const inProgressCoursesArgs = {
      status: 'publish',
      role: 'tela-admin',
      'filter[meta_key]': 'assessment_progress',
      'filter[meta_compare]': '=',
      'filter[meta_value]': 'in-progress',
      progress: 'in-progress',
      userToken: this.userToken,
    };
    this.getCoursesByUser(inProgressCoursesArgs);

    const completedAssessmentArgs = {
      status: 'publish',
      role: 'tela-admin',
      'filter[meta_key]': 'compare_ready',
      'filter[meta_compare]': '=',
      'filter[meta_value]': 'yes',
      progress: 'completed',
      userToken: this.userToken,
    };
    this.getCoursesByUser(completedAssessmentArgs);
    const testCoursesArguments = {
      status: 'publish',
      role: 'tela-admin',
      'filter[meta_key]': 'forTest',
      'filter[meta_compare]': '=',
      'filter[meta_value]': 'yes',
      progress: 'test-courses',
      userToken: this.userToken,
    };
    this.getCoursesByUser(testCoursesArguments);
  },
  methods: {
    ...mapActions('user', {
      validateToken: 'validateToken',
    }),
    ...mapActions('dashboard', {
      getCoursesByUser: 'getCoursesByUser',
    }),
  },
};
</script>
